import { useI18n, type Language } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import { languageOptions } from "./languages";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { language, setLanguage, t } = useI18n();
  const selectedLanguage = languageOptions.find(
    (item) => item.code === language,
  );

  return (
    <div
      className={cn("inline-flex items-center", className)}
      aria-label={t("language.select")}
    >
      <Select
        value={language}
        onValueChange={(value) => setLanguage(value as Language)}
      >
        <SelectTrigger
          aria-label={t("language.select")}
          className="h-8 w-12 rounded-md px-2 text-xs"
        >
          <SelectValue>
            {selectedLanguage ? (
              <span className="flex items-center">
                <span className="text-base leading-none" aria-hidden="true">
                  {selectedLanguage.flag}
                </span>
                <span className="sr-only">{t(selectedLanguage.nameKey)}</span>
              </span>
            ) : null}
          </SelectValue>
        </SelectTrigger>
        <SelectContent align="end" className="min-w-12">
          {languageOptions.map((item) => (
            <SelectItem
              key={item.code}
              value={item.code}
              aria-label={t(item.nameKey)}
              className="pr-2 pl-7"
            >
              <span className="flex items-center" aria-label={t(item.nameKey)}>
                <span className="text-base leading-none" aria-hidden="true">
                  {item.flag}
                </span>
                <span className="sr-only">{t(item.nameKey)}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
